export default {
    groups: [
        {
            id: 1,
            label: 'Реквизиты',
            collapsed: false,
        },
        {
            id: 2,
            label: 'Даты',
            collapsed: false,
        },
        {
            id: 3,
            label: 'Статус',
            collapsed: false,
        },
        {
            id: 4,
            label: 'Переоформления',
            collapsed: false,
        },
        {
            id: 5,
            label: 'Банковские реквизиты',
            collapsed: false,
        },
        {
            id: 6,
            label: 'Финансы',
            collapsed: false,
        },
        {
            id: 7,
            label: 'Адреса',
            collapsed: false,
        },
        {
            id: 8,
            label: 'Реквизиты электрического договора',
            collapsed: false,
        },
    ],
    components: [
        // GROUP 1
        {
            fieldType: 'ai-form-text-box-readonly',
            title: 'Номер',
            groupId: 1,
            size: [1, 2],
            fieldNameText: 'ndog',
        },
        {
            name: 'component-subdivision',
            groupId: 1,
            size: [1, 2],
        },

        {
            fieldType: 'ai-form-text-box',
            title: 'Идентификатор госконтракта',
            groupId: 1,
            size: [1, 2],
            fieldNameText: 'id_gk',
        },
        {
            fieldType: 'ai-form-select-box',
            title: 'Договор',
            fieldNameText: 'tep_el',
            fieldNameId: 'tep_el_name',
            groupId: 1,
            size: [1, 1],
            extParams: {
                valueExpr: 'tep_el',
                displayExpr: 'name',
                dictionaryRoutePath: 'counteragent./customer/dict/tep_el/get',
            },
        },
        {
            name: 'component-type',
            groupId: 1,
            size: [1, 3],
        },
        {
            fieldType: 'ai-form-text-box',
            title: 'Ид. код',
            fieldNameText: 'ikz',
            groupId: 1,
            size: [1, 1],
        },
        {
            fieldType: 'ai-form-text-box-readonly',
            title: 'Ид. внеш. системы',
            fieldNameText: 'es_id',
            groupId: 1,
            size: [1, 1],
        },
        {
            fieldType: 'ai-form-text-box-virtual-grid-dictionary',
            title: 'Источник финансирования',
            fieldNameId: 'kod_ist',
            fieldNameText: 'name_ist',
            groupId: 1,
            size: [1, 6],
            validationRules: {
                required: false,
            },
            extParams: {
                displayExpr: 'name',
                valueExpr: 'kod_ist',
                meta_args: {
                    key: 'kod_ist',
                    db_schema_name: 'dog',
                    db_view_name: 'kv_istfin',
                },
                columns: [
                    {field: 'kod_ist', text: 'kod_ist', visible: false},
                    {field: 'npp', text: '№ п/п', width: 50},
                    {field: 'name', text: 'Наименование', width: 200},
                    {field: 'name_bank', text: 'Банк получателя (по умолчанию)', width: 200},
                ],
                loadUrl: 'contract./card/data/get',
                keyExpr: 'kod_ist',
                autoLoadData: false,
                toRemoveToolbarItemsNames: ['copy', 'edit', 'add', 'delete', 'save'],
            },
        },
        {
            fieldType: 'ai-form-text-box-virtual-grid-dictionary',
            groupId: 1,
            title: 'Плательщик',
            size: [1, 3],
            fieldNameId: 'kodp_plat',
            fieldNameText: 'plat_name',
            validationRules: {
                required: false,
            },
            extParams: {
                displayExpr: 'name',
                valueExpr: 'kodp',
                meta_args: {
                    key: 'kodp',
                    db_schema_name: 'payer',
                    db_view_name: 'mvi_customer',
                },
                columns: [
                    {field: 'kodp', text: 'kodp', visible: false},
                    {field: 'nump', text: 'Номер', width: 100},
                    {field: 'inn', text: 'ИНН', width: 100},
                    {field: 'name', text: 'Наименование', width: 100},
                    {field: 'allname', text: 'Полное наименование', width: 200},
                ],
                loadUrl: 'contract./card/data/get',
                keyExpr: 'kodp',
                autoLoadData: false,
                toRemoveToolbarItemsNames: ['copy', 'edit', 'add', 'delete', 'save'],
            },
        },
        {
            fieldType: 'ai-form-text-box-virtual-grid-dictionary',
            groupId: 1,
            title: 'Грузополучатель',
            size: [1, 3],
            fieldNameId: 'kodp_gruz',
            fieldNameText: 'gruz_name',
            validationRules: {
                required: false,
            },
            extParams: {
                displayExpr: 'name',
                valueExpr: 'kodp',
                meta_args: {
                    key: 'kodp',
                    db_schema_name: 'payer',
                    db_view_name: 'mvi_customer',
                },
                columns: [
                    {field: 'kodp', text: 'kodp', visible: false},
                    {field: 'nump', text: 'Номер', width: 100},
                    {field: 'inn', text: 'ИНН', width: 100},
                    {field: 'name', text: 'Наименование', width: 100},
                    {field: 'allname', text: 'Полное наименование', width: 200},
                ],
                loadUrl: 'contract./card/data/get',
                keyExpr: 'kodp',
                autoLoadData: false,
                toRemoveToolbarItemsNames: ['copy', 'edit', 'add', 'delete', 'save'],
            },
        },
        // GROUP 2
        {
            fieldType: 'ai-form-date-box',
            title: 'Начало действия',
            fieldNameText: 'dat_dog',
            groupId: 2,
            size: [1, 2],
        },
        {
            fieldType: 'ai-form-date-box',
            title: 'Планируемое окончание',
            fieldNameText: 'dat_srok',
            groupId: 2,
            size: [1, 1],
        },
        {
            fieldType: 'ai-form-date-box',
            title: 'Прекращение',
            fieldNameText: 'dat_fin',
            groupId: 2,
            size: [1, 1],
        },
        {
            fieldType: 'ai-form-date-box',
            title: 'Архивация',
            fieldNameText: 'dat_arhiv',
            groupId: 2,
            size: [1, 2],
        },
        {
            fieldType: 'ai-form-date-box',
            title: 'Пролонгация',
            fieldNameText: 'dat_prolong',
            groupId: 2,
            size: [1, 1],
        },
        {
            fieldType: 'ai-form-date-box',
            title: 'Подписан ЮЛ',
            fieldNameText: 'dat_sign',
            groupId: 2,
            size: [1, 1],
        },
        {
            fieldType: 'ai-form-date-box',
            title: 'Регистрация',
            fieldNameText: 'dat_numdog',
            groupId: 2,
            size: [1, 2],
        },
        {
            fieldType: 'ai-form-date-box',
            title: 'Дата направления оферты',
            fieldNameText: 'dat_oferta',
            groupId: 2,
            size: [1, 1],
        },
        {
            fieldType: 'ai-form-date-box',
            title: 'Начало поставки э/э',
            fieldNameText: 'dat_postavka',
            groupId: 2,
            size: [1, 1],
        },

        // GROUP 3
        {
            name: 'component-status',
            groupId: 3,
            size: [1, 1],
        },
        {
            fieldType: 'ai-form-text-box',
            title: 'Причина расторжения',
            fieldNameText: 'rast_dog',
            groupId: 3,
            size: [1, 5],
        },

        // GROUP 4
        {
            fieldType: 'ai-form-text-box-readonly',
            title: 'Договор переоформлен с договора №',
            fieldNameText: 'parent_dog_info',
            groupId: 4,
            size: [1, 3],
        },
        {
            fieldType: 'ai-form-text-box-readonly',
            title: 'Договор переоформлен на договор №',
            fieldNameText: 'child_dog_info',
            groupId: 4,
            size: [1, 3],
        },

        // GROUP 5
        {
            name: 'component-receiver',
            groupId: 5,
            size: [1, 6],
        },
        {
            fieldType: 'ai-form-text-box-virtual-grid-dictionary',
            title: 'Банк получателя',
            fieldNameId: 'kodbpol',
            fieldNameText: 'bank_pol',
            groupId: 5,
            size: [1, 4],
            validationRules: {
                required: false,
            },
            extParams: {
                displayExpr: 'name_bank',
                valueExpr: 'kodb',
                meta_args: {
                    key: 'kodbpol',
                    db_schema_name: 'dog',
                    db_view_name: 'kv_bankpol',
                },
                columns: [
                    {field: 'kodbpol', text: 'kodp', visible: false},
                    {field: 'npp', text: '№ п/п', width: 20},
                    {field: 'ocher_plat', text: 'Очерёдность платежа', width: 100},
                    {field: 'rs', text: 'Расчётный счёт', width: 100},
                    {field: 'name_bank', text: 'Наименование банка', width: 200},
                    {field: 'filial', text: 'Наименование филиала', width: 200},
                    {field: 'bic', text: 'БИК', width: 50},
                    {field: 'ks', text: 'Кор. счёт', width: 100},
                    {field: 'adr', text: 'Адрес', width: 200},
                    {field: 'p_ind', text: 'Индекс', width: 50},
                    {field: 'name_dep', text: 'Отделение', width: 200},
                    {field: 'predel', text: 'Минимальная сумма платёжного док-та (руб.)', width: 50},
                    {field: 'pr_active', text: 'Удалён', width: 50},
                    {field: 'copys', text: 'Кол-во копий при печати к реестру', width: 100},
                    {field: 'dat_otkr', text: 'Дата открытия', width: 100},
                    {field: 'dat_fin', text: 'Дата закрытия', width: 100},
                    {field: 'remark', text: 'Примечание', width: 200},
                    {field: 'days_accept', text: 'Кол-во дней для акцепта', width: 200},
                    {field: 'service', text: 'Код услуги', width: 100},
                ],
                loadUrl: 'contract./card/data/get',
                keyExpr: 'kodbpol',
                autoLoadData: false,
                toRemoveToolbarItemsNames: ['copy', 'edit', 'add', 'delete', 'save'],
                additionalFiels: [
                    {cardFieldName: 'rs_b_pol', dictFieldName: 'rs'},
                    {cardFieldName: 'bic_b_pol', dictFieldName: 'bic'},
                    {cardFieldName: 'adr_b_pol', dictFieldName: 'adr'},
                    {cardFieldName: 'ks_b_pol', dictFieldName: 'ks'},
                ]
            },
        },
        {
            name: 'component-receiver-checking-acc',
            groupId: 5,
            size: [1, 2],
        },
        {
            fieldType: 'ai-form-text-box-readonly',
            title: 'БИК',
            fieldNameText: 'bic_b_pol',
            groupId: 5,
            size: [1, 1],
        },
        {
            fieldType: 'ai-form-text-box-readonly',
            title: 'Адрес',
            fieldNameText: 'adr_b_pol',
            groupId: 5,
            size: [1, 3],
        },
        {
            fieldType: 'ai-form-text-box-readonly',
            title: 'Кор, счёт',
            fieldNameText: 'ks_b_pol',
            groupId: 5,
            size: [1, 2],
        },
        {
            name: 'component-payer-headline',
            groupId: 5,
            size: [1, 6],
        },
        {
            fieldType: 'ai-form-text-box-tree-list-dictionary',
            fieldNameId: 'kodbpl',
            title: 'Банк',
            fieldNameText: 'bank_plat',
            groupId: 5,
            size: [1, 4],
            validationRules: {
                required: false,
            },
            extParams: {
                displayExpr: 'name',
                valueExpr: 'kodb',
                dictionaryRoutePath: 'counteragent./contract/dict/bank/get',
                allowSelectParentNodes: true,
                metaDictionary: {
                    label: '',
                    keyExpr: 'kodb',
                    parentIdExpr: 'kod_parent',
                    focusedRowEnabled: true,
                    rootValue: 0,
                    columns: [
                        { dataField: 'kodb', caption: 'kodp', visible: false },
                        { dataField: 'name', caption: 'Наименование', width: 250 },
                        {
                            caption: 'Сокращенное наименование',
                            dataField: 'abbr',
                            width: 200,
                        },
                        {
                            caption: 'Номер банка',
                            dataField: 'kodb',
                            width: 150,
                        },
                        {
                            caption: 'Филиал',
                            dataField: 'filial',
                            width: 250,
                        },
                        {
                            caption: 'БИК',
                            dataField: 'bic',
                            width: 200,
                        },
                        {
                            caption: 'Адрес (старый формат)',
                            dataField: 'adr',
                            width: 250,
                        },
                        {
                            caption: 'Корр. счет',
                            dataField: 'ks',
                            width: 250,
                        },
                        {
                            caption: 'Индекс',
                            dataField: 'p_ind',
                            width: 150,
                        },
                        {
                            caption: 'Адрес (из справочника адресов)',
                            dataField: 'adres',
                            width: 250,
                        },
                        {
                            caption: 'Город',
                            dataField: 'town',
                            width: 250,
                        },
                        {
                            caption: 'Удален',
                            dataField: 'status',
                            width: 250,
                        },
                        {
                            caption: 'ОГРН',
                            dataField: 'ogrn',
                            width: 250,
                        },
                        {
                            caption: 'ИНН',
                            dataField: 'inn',
                            width: 250,
                        },
                        {
                            caption: 'КПП',
                            dataField: 'kpp',
                            width: 250,
                        },
                        {
                            caption: 'ОКОПФ',
                            dataField: 'okopf',
                            width: 250,
                        },
                        {
                            caption: 'Примечание',
                            dataField: 'prim',
                            width: 250,
                        },
                        {
                            caption: 'npp',
                            dataField: 'npp',
                            width: 250,
                        },
                        {
                            caption: 'Телефон',
                            dataField: 'telefon',
                            width: 250,
                        },
                        {
                            caption: 'Обработка платежных требований',
                            dataField: 'name_pay',
                            width: 250,
                        },
                    ],
                },
            },
        },
        {
            fieldType: 'ai-form-text-box',
            title: 'Расчётный счёт',
            fieldNameText: 'rassh1',
            groupId: 5,
            size: [1, 2],
        },
        {
            fieldType: 'ai-form-text-box-readonly',
            title: 'БИК',
            fieldNameText: 'bic_b_pl',
            groupId: 5,
            size: [1, 1],
        },
        {
            fieldType: 'ai-form-text-box-readonly',
            title: 'Адрес',
            fieldNameText: 'adr_b_pl',
            groupId: 5,
            size: [1, 3],
        },
        {
            fieldType: 'ai-form-text-box-readonly',
            title: 'Кор. счёт',
            fieldNameText: 'ks_b_pl',
            groupId: 5,
            size: [1, 2],
        },
        {
            fieldType: 'ai-form-text-box',
            title: 'Доп. банковский счёт',
            fieldNameText: 'dop_bank_rs',
            groupId: 5,
            size: [1, 3],
        },
        {
            fieldType: 'ai-form-text-box-readonly',
            title: 'Доп. счета ЮЛ',
            fieldNameText: 'dop_bank_name',
            groupId: 5,
            size: [1, 3],
        },
        {
            name: 'component-kazn-divider',
            groupId: 5,
            size: [1, 6],
        },
        {
            fieldType: 'ai-form-text-box-virtual-grid-dictionary',
            title: 'Казначейство',
            fieldNameId: 'kod_kazn',
            fieldNameText: 'kazn_name',
            groupId: 5,
            size: [1, 4],
            validationRules: {
                required: false,
            },
            extParams: {
                displayExpr: 'name',
                valueExpr: 'kod_kazn',
                meta_args: {
                    key: 'kod_kazn',
                    db_schema_name: 'dog',
                    db_view_name: 'ks_kazn',
                },
                columns: [
                    {field: 'kod_kazn', text: 'kod_kazn', visible: false},
                    {field: 'name', text: 'Наименование', width: 250},
                    {field: 'inn', text: 'ИНН', width: 150},
                    {field: 'rs', text: 'Расчётный счёт', width: 150},
                    {field: 'npp', text: 'Номер', width: 100},
                    {field: 'okrk', text: '№ округа казначейства', width: 100},
                    {field: 'allname', text: 'Полное наименование', width: 250},
                ],
                loadUrl: 'contract./card/data/get',
                keyExpr: 'kod_kazn',
                autoLoadData: false,
                toRemoveToolbarItemsNames: ['copy', 'edit', 'add', 'delete', 'save'],
            },
        },
        {
            fieldType: 'ai-form-text-box',
            title: '№ лиц. счёта',
            fieldNameText: 'lic_kazn',
            groupId: 5,
            size: [1, 2],
        },

        // GROUP 6
        {
            fieldType: 'ai-form-select-box',
            title: 'Тип док-та начислений',
            fieldNameId: 'osn_fin_doc_txt',
            fieldNameText: 'osn_fin_doc',
            groupId: 6,
            size: [1, 2],
            extParams: {
                valueExpr: 'osn_fin_doc',
                displayExpr: 'osn_fin_doc_txt',
                dictionaryRoutePath: 'counteragent./contract/dict/osn_fin_doc/get',
            },
        },
        {
            fieldType: 'ai-form-text-box',
            title: 'Префикс № счёт-фактуры',
            fieldNameText: 'pref_fac_',
            groupId: 6,
            size: [1, 2],
        },
        {
            fieldType: 'ai-form-check-box-readonly',
            title: 'Наличие ЭЦП',
            fieldNameText: 'ecp',
            groupId: 6,
            size: [1, 2],
        },
        {
            fieldType: 'ai-form-select-box',
            title: 'Тип основного плат. док-та',
            fieldNameId: 'vpl_name',
            fieldNameText: 'vid_pl',
            groupId: 6,
            size: [1, 3],
            extParams: {
                valueExpr: 'vid_pl',
                displayExpr: 'name',
                dictionaryRoutePath: 'counteragent./contract/dict/vid_pl/get',
            },
        },
        {
            fieldType: 'ai-form-select-box',
            title: 'Состояние плат. док-та по умолчанию',
            fieldNameId: 'state_name',
            fieldNameText: 'kod_state',
            groupId: 6,
            size: [1, 3],
            extParams: {
                valueExpr: 'kod_state',
                displayExpr: 'name',
                dictionaryRoutePath: 'counteragent./contract/dict/fin_doc_state/get',
            },
        },
        {
            fieldType: 'ai-form-text-box-virtual-grid-dictionary',
            title: 'Дни до наступления задолженности',
            fieldNameId: 'kod_bzad',
            fieldNameText: 'day_bzad_name',
            groupId: 6,
            size: [1, 2],

            validationRules: {
                required: false,
            },
            extParams: {
                displayExpr: 'day_bzad_name',
                valueExpr: 'kod_bzad',
                meta_args: {
                    key: 'kod_bzad',
                    db_schema_name: 'fin_doc',
                    db_view_name: 'sv_zadol_day',
                },
                columns: [
                    {field: 'kod_bzad', text: 'kod_bzad', visible: false},
                    {field: 'days_bzad', text: 'Кол-во дней до наступления задолженности', width: 200},
                    {field: 'name', text: 'Способ указания дней задолженности', width: 300},
                    {field: 'no_less', text: 'Дней не менее', width: 100},
                ],
                loadUrl: 'contract./card/data/get',
                keyExpr: 'kod_bzad',
                autoLoadData: false,
                toRemoveToolbarItemsNames: ['copy', 'edit', 'add', 'delete', 'save'],
            },


        },
        {
            fieldType: 'ai-form-select-box',
            title: 'Тип оплаты',
            fieldNameText: 'kod_spos_opl',
            fieldNameId: 'spos_opl_name',
            groupId: 6,
            size: [1, 2],
            extParams: {
                valueExpr: 'kod_spos_opl',
                displayExpr: 'name',
                dictionaryRoutePath: 'counteragent./contract/dict/spos_opl/get',
            },
        },
        {
            fieldType: 'ai-form-check-box',
            title: 'Искл. автомат. разноса оплат',
            fieldNameText: 'noauto_opl',
            groupId: 6,
            size: [1, 2],
        },

        // GROUP 7
        {
            fieldType: 'ai-form-text-box-virtual-grid-dictionary',
            title: 'Адрес для переписки',
            fieldNameId: 'kod_d_p_dog',
            fieldNameText: 'd_p_dog_text',
            groupId: 7,
            size: [1, 6],
            validationRules: {
                required: true,
            },
            extParams: {
                displayExpr: 'kf_adress_o',
                valueExpr: 'kodd',
                meta_args: {
                    key: 'kodd',
                    db_schema_name: 'address',
                    db_view_name: 'mvi_kv_address',
                },
                columns: [
                    {field: 'kodd', text: 'kodd', visible: false},
                    {field: 'postcode', text: 'Почтовый индекс', width: 100},
                    {field: 'region', text: 'Субъект федерации', width: 100},
                    {field: 'district', text: 'Район (адм.)', width: 100},
                    {field: 'city', text: 'Город (адм.)', width: 100},
                    {field: 'place', text: 'Населенный пункт', width: 100},
                    {field: 'street', text: 'Улица', width: 200},
                    {field: 'house', text: 'Дом (здание, сооружен. и т.д.)', width: 100},
                    {field: 'flat', text: 'Помещение в пределах дома', width: 50},
                    {field: 'room', text: 'Комната', width: 50},
                    {field: 'guid', text: 'GUID ГАР', width: 200},
                    {field: 'mark_addr', text: 'Краткое написание адреса'},
                    {
                        field: 'district_m',
                        text: 'Муниципальный р-н (округ) \\ Городской округ \\ Внутригородская терр. ГФЗ',
                        visible: false
                    },
                    {
                        field: 'poselen_m',
                        text: 'Городское(сельское) поселение \\ Межселенная территория \\ Внутригородской р-н Г.О.',
                        visible: false
                    },
                    {field: 'plan', text: 'Планировочная структура', visible: false},
                    {field: 'kf_adress_o', text: 'kf_adress_o', visible: false},
                ],
                loadUrl: 'e-grid./address/data/get',
                keyExpr: 'kodd',
                autoLoadData: false,
                toRemoveToolbarItemsNames: ['copy', 'edit', 'add', 'delete', 'save'],
            },
        },
        {
            fieldType: 'ai-form-text-box-virtual-grid-dictionary',
            title: 'Адрес местонахождения',
            fieldNameId: 'kod_d_dog',
            fieldNameText: 'd_dog_text',
            groupId: 7,
            size: [1, 6],
            validationRules: {
                required: true,
            },
            extParams: {
                displayExpr: 'kf_adress_o',
                valueExpr: 'kodd',
                meta_args: {
                    key: 'kodd',
                    db_schema_name: 'address',
                    db_view_name: 'mvi_kv_address',
                },
                columns: [
                    {field: 'kodd', text: 'kodd', visible: false},
                    {field: 'postcode', text: 'Почтовый индекс', width: 100},
                    {field: 'region', text: 'Субъект федерации', width: 100},
                    {field: 'district', text: 'Район (адм.)', width: 100},
                    {field: 'city', text: 'Город (адм.)', width: 100},
                    {field: 'place', text: 'Населенный пункт', width: 100},
                    {field: 'street', text: 'Улица', width: 200},
                    {field: 'house', text: 'Дом (здание, сооружен. и т.д.)', width: 100},
                    {field: 'flat', text: 'Помещение в пределах дома', width: 50},
                    {field: 'room', text: 'Комната', width: 50},
                    {field: 'guid', text: 'GUID ГАР', width: 200},
                    {field: 'mark_addr', text: 'Краткое написание адреса'},
                    {
                        field: 'district_m',
                        text: 'Муниципальный р-н (округ) \\ Городской округ \\ Внутригородская терр. ГФЗ',
                        visible: false
                    },
                    {
                        field: 'poselen_m',
                        text: 'Городское(сельское) поселение \\ Межселенная территория \\ Внутригородской р-н Г.О.',
                        visible: false
                    },
                    {field: 'plan', text: 'Планировочная структура', visible: false},
                    {field: 'kf_adress_o', text: 'kf_adress_o', visible: false},
                ],
                loadUrl: 'e-grid./address/data/get',
                keyExpr: 'kodd',
                autoLoadData: false,
                toRemoveToolbarItemsNames: ['copy', 'edit', 'add', 'delete', 'save'],
            },
        },

        // GROUP 8
        {
            name: 'component-main-place',
            groupId: 8,
            size: [1, 6],
        },
        {
            fieldType: 'ai-form-text-box-tree-list-dictionary',
            fieldNameId: 'kod_group_cust',
            title: 'Группа потребителей эл. энергии',
            fieldNameText: 'gr_cust_name',
            groupId: 8,
            size: [1, 6],
            validationRules: {
                required: false,
            },
            extParams: {
                displayExpr: 'name',
                valueExpr: 'kod_group_cust',
                dictionaryRoutePath: 'counteragent./contract/dict/group_cust/get',
                metaDictionary: {
                    label: '',
                    keyExpr: 'kod_group_cust',
                    parentIdExpr: 'kod_gr_parent',
                    focusedRowEnabled: true,
                    rootValue: 0,
                    columns: [
                        {
                            dataField: 'num_cust',
                            caption: 'Номер',
                            width: '200px',
                        },
                        {
                            dataField: 'name',
                            caption: 'Наименование',
                            width: '200px',
                        },
                        {
                            dataField: 'fin_name',
                            caption: 'Наименование для ФО',
                            width: '200px',
                        },
                        {
                            dataField: 'name_tep_el',
                            caption: 'Тип',
                            width: '200px',
                        },
                        {
                            dataField: 'name_status',
                            caption: 'Статус',
                            width: '200px',
                        },
                    ],
                },
            },
        },
        {
            fieldType: 'ai-form-text-box',
            title: 'Дата снятия показаний',
            fieldNameText: 'day_pokaz',
            fieldName: 'day_pokaz_name',
            groupId: 8,
            size: [1, 6],
        },
        {
            fieldType: 'ai-form-text-box',
            title: 'Порция эл. расчетов по умолчанию',
            fieldNameText: 'porciya',
            groupId: 8,
            size: [1, 6],
        },
    ],
};
